import React, { useContext } from "react";

const LangContext = React.createContext({});

export const LangProvider = LangContext.Provider;

export const useLang = () => useContext(LangContext);